import { render, staticRenderFns } from "./BottomSafetyTips.vue?vue&type=template&id=c1855f8e&scoped=true&"
import script from "./BottomSafetyTips.vue?vue&type=script&lang=ts&"
export * from "./BottomSafetyTips.vue?vue&type=script&lang=ts&"
import style0 from "./BottomSafetyTips.vue?vue&type=style&index=0&id=c1855f8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1855f8e",
  null
  
)

export default component.exports